import { QuickStartCard } from "./QuickStartCard";

export default QuickStartCard;
